const getters = {
  sidebar: state => state.app.sidebar,
  menuStatus: state => state.app.menuStatus,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  username: state => state.user.username,
  resources: state => state.user.resources,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission_routers: state => state.permission.routers,
  async_routers: state => state.permission.asyncRouter
};
export default getters;
